function toYm(key) {
  const m = String(key || '').match(/^(\d{4})-(\d{2})$/)
  if (!m) return 0
  return Number(`${m[1]}${m[2]}`)
}

export function evaluateLegalConsistency(rows = [], expediente = {}, activeRules = {}) {
  const issues = []
  const data = Array.isArray(rows) ? rows : []
  const simulationMode = Boolean(expediente?.__simulationMode)
  const cese = String(expediente?.fechaCese || '').slice(0, 7)
  const ceseYm = toYm(cese)

  if (!ceseYm) issues.push('Falta fecha de cese valida para justificar doctrina e indice aplicable.')
  if (Number(expediente?.haberActual || 0) <= 0) issues.push('Haber actual ANSES no informado o no valido.')
  if (data.some((r) => r.invalidIndex)) issues.push('Hay periodos con indice faltante/invalido en base legal.')

  const projectedCount = data.filter((r) => Boolean(r.projected)).length
  if (projectedCount > 0 && !String(expediente?.fechaCeseEstimada || '').trim() && !String(expediente?.fechaCese || '').trim()) {
    issues.push('Existen periodos proyectados sin fecha de cese/escenario explicitado.')
  }

  const prescripcionIndeterminada = data.some((r) => Boolean(r.prescripcionIndeterminada))
  if (prescripcionIndeterminada && !simulationMode) {
    issues.push('Prescripcion indeterminada: faltan hitos obligatorios (alta del beneficio, reclamo administrativo, denegatoria o demanda).')
  }

  const hasTasaVencida = data.some((r) => r.tasaInteresVigente === false)
  if (hasTasaVencida) issues.push('Tasa de interes sin vigencia para fecha de corte informada.')

  const divisorPolicy = String(activeRules?.protocol?.divisorPolicy || 'legal_120')
  if (!['legal_120', 'muestra_efectiva', 'especial_docente', 'prorrateado_docente_mixto'].includes(divisorPolicy)) {
    issues.push(`Policy de divisor no reconocida: ${divisorPolicy}.`)
  }

  const scenarioKey = String(activeRules?.caseMeta?.scenarioKey || '')
  const isDocenteScenario = scenarioKey.includes('DOCENTE')
  if (isDocenteScenario) {
    const sueldoBruto = Number(expediente?.datosDocentes?.sueldoBrutoCargoCese || 0)
    const mesesContinuos = Number(expediente?.datosDocentes?.mesesEnCargoContinuos || 0)
    const mesesAlternados = Number(expediente?.datosDocentes?.mesesEnCargoAlternados || 0)
    const mesesInformados = Math.max(mesesContinuos, mesesAlternados)
    const cumpleMeses = mesesContinuos >= 60 || mesesAlternados >= 120
    if (!(sueldoBruto > 0) || !(mesesInformados > 0) || !cumpleMeses) {
      issues.push('Caso configurado como Especial Docente pero carece de la informacion del cargo al cese requerida por el Dec. 137/05')
    }
  }

  const severity = issues.length >= 3 ? 'alta' : (issues.length > 0 ? 'media' : 'baja')
  return {
    passed: issues.length === 0,
    severity,
    issues,
  }
}
